import { render, staticRenderFns } from "./DigitalPaperSheetEdit.vue?vue&type=template&id=04c6663e&scoped=true&"
import script from "./DigitalPaperSheetEdit.vue?vue&type=script&lang=ts&"
export * from "./DigitalPaperSheetEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DigitalPaperSheetEdit.vue?vue&type=style&index=0&id=04c6663e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c6663e",
  null
  
)

export default component.exports